import React from "react";
import ArrowUpwardRoundedIcon from "@material-ui/icons/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@material-ui/icons/ArrowDownwardRounded";
import RemoveRoundedIcon from "@material-ui/icons/RemoveRounded";

const LabelChartProgresLiterasi = ({
    title,
    skor,
    prosentase,
}) => {
    require("./Ensa.css");
    return (
        <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
            <div className="pnl-title-chart">
                <div className="label-title">{title}</div>
                <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                    <div className="label-skor">{skor}</div>
                    <div className="label-progres">+{prosentase}%</div>
                </div>
            </div>
        </div>

    );
};

export default LabelChartProgresLiterasi;
